import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const items = ['Videos en inglés y cursos internacionales que no aplican a Argentina', 'No sabés qué vender ni cómo encontrar productos con demanda real', 'Publicaste y nadie compra — no sabés si el problema es título, foto o precio', 'Querés empezar sin invertir miles en mercadería', 'No conocés proveedores mayoristas locales confiables', 'Domingo a la noche viendo el homebanking pensando que algo tiene que cambiar'];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-256">
      <div className="max-w-4xl mx-auto" data-id="element-257">
        {/* PAIN INTRO */}
        <div className="text-center mb-10 md:mb-14" data-id="element-258">
          <p className="text-red-400 font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-259">
            💣 La realidad del emprendedor que arranca
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-3xl mx-auto" data-id="element-260">
            ¿Cuántos meses más vas a esperar para{' '}
            <span className="text-primary" data-id="element-261">empezar?</span>
          </h2>
          <p className="text-base md:text-lg text-zinc-300 leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-262">
            Querés generar un ingreso extra desde casa. Sabés que Mercado Libre
            es la plataforma más grande del país y que millones de personas
            compran ahí todos los días. Pero nadie te dio un sistema pensado
            para la realidad del emprendedor argentino que empieza desde cero.
            Buscás cómo vender en ML y todo lo que encontrás son videos en
            inglés, cursos de dropshipping internacional o promesas de hacerte
            rico en 30 días que{' '}
            <span className="text-white font-semibold" data-id="element-263">
              no aplican a Argentina.
            </span>
          </p>
        </div>

        {/* PAIN POINTS VISUAL */}
        <div className="mb-10" data-id="element-264">
          <h3 className="text-xl md:text-2xl font-bold text-center mb-8 leading-tight" data-id="element-265">
            Esto es lo que te está drenando{' '}
            <span className="text-red-400" data-id="element-266">tiempo, energía y autoridad</span>
          </h3>

          <div className="grid sm:grid-cols-2 gap-3 md:gap-4" data-id="element-267">
            {items.map((item, i) => <div key={i} className="bg-surface border border-zinc-800 rounded-xl p-4 md:p-5 flex items-start gap-3 hover:border-red-500/30 transition-colors" data-id="element-268">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 shrink-0 mt-0.5" data-id="element-269" />
                <span className="text-zinc-200 text-sm md:text-base" data-id="element-270">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* GOLPE DE MENSAJE */}
        <div className="text-center bg-black/40 border border-primary/30 rounded-2xl p-6 md:p-8" data-id="element-271">
          <p className="text-lg md:text-2xl font-bold text-zinc-300 leading-tight" data-id="element-272">
            No es falta de ganas.
            <br data-id="element-273" />
            No es falta de capacidad.
            <br data-id="element-274" />
            <span className="text-primary text-xl md:text-3xl" data-id="element-275">
              Es falta de un sistema.
            </span>
          </p>
        </div>
      </div>
    </section>;
}